import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faBars, faXmark, faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { useState } from "react";

export const Header = () => {
    const [showMenu, setShowMenu] = useState(false);
    const closeMenu = () => setShowMenu(false);

    return (
        <>
            <div className="kf-top-bar" role="presentation" />
            <header className="kf-header">
                <nav className="container kf-header__nav d-flex justify-content-between align-items-center" aria-label="Main">
                    <Link to="/" aria-label="KegFinder home" onClick={closeMenu}>
                        <img src="/images/logo.svg" alt="KegFinder" className="kf-header__logo" title="KegFinder" />
                    </Link>

                    {/* Desktop navigation */}
                    <div className="d-none d-sm-flex gap-2">
                        <LinkContainer to="/contact">
                            <Button variant="outline-light" title="Contact us">
                                <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                Contact
                            </Button>
                        </LinkContainer>
                        <LinkContainer to="/submit-retailer">
                            <Button variant="light" title="Submit a retailer">
                                <FontAwesomeIcon icon={faArrowUpFromBracket} className="me-2" />
                                Submit retailer
                            </Button>
                        </LinkContainer>
                    </div>

                    {/* Mobile toggle */}
                    <Button
                        variant="outline-light"
                        className="d-sm-none"
                        onClick={() => setShowMenu(!showMenu)}
                        aria-label={showMenu ? "Collapse menu" : "Expand menu"}
                        aria-expanded={showMenu}
                    >
                        <FontAwesomeIcon icon={showMenu ? faXmark : faBars} fixedWidth />
                    </Button>
                </nav>

                {/* Mobile drawer */}
                {showMenu && (
                    <div className="container d-sm-none">
                        <nav className="kf-header__mobile-menu d-grid gap-2" aria-label="Mobile Navigation">
                            <LinkContainer to="/contact" onClick={closeMenu}>
                                <Button variant="outline-light">
                                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                    Contact us
                                </Button>
                            </LinkContainer>
                            <LinkContainer to="/submit-retailer" onClick={closeMenu}>
                                <Button variant="light">
                                    <FontAwesomeIcon icon={faArrowUpFromBracket} className="me-2" />
                                    Submit retailer
                                </Button>
                            </LinkContainer>
                        </nav>
                    </div>
                )}
            </header>
        </>
    );
};